import { AlertType } from '@/types/responseTypes';

export type AlertImage = 'image_good' | 'image_bad' | 'document';

const DECLINING_ALERT_TYPES = new Set<AlertType>([
  // Account status getting worse
  'LP_To1_Tny', 'LP_To1_Sml', 'LP_To1_Med', 'LP_To1_Lge',
  'LP_To2_Tny', 'LP_To2_Sml', 'LP_To2_Med', 'LP_To2_Lge',
  'LP_To3_Tny', 'LP_To3_Sml', 'LP_To3_Med', 'LP_To3_Lge',
  'NL_To1_Sml', 'NL_To1_Lge', 'NL_To2_Sml', 'NL_To2_Lge', 'NL_To3_Sml', 'NL_To3_Lge',
  'HC_To1_All', 'HC_To2_All', 'HC_To3_All',
  'RC_To1_All', 'LN_To1_All', 'LN_To3P', 'RC_To3P', 'BK_To3P',
  // Mortgage account status getting worse
  'MG_To1_All', 'MG_To2_All', 'MG_To3_All',
  // Default
  'LP_ToDef_Tny', 'LP_ToDef_Sml', 'LP_ToDef_Med', 'LP_ToDef_Lge',
  'NL_ToDef_All', 'HC_ToDef_All', 'MG_ToDef_All',
  // Noticeable balance increase
  'Inc_Sml_Bal_SM', 'Inc_Sml_Bal_Lge', 'Inc_Med_Bal_SM', 'Inc_Med_Bal_Lge',
  'Inc_Lge_Bal_SM', 'Inc_Lge_Bal_Lge',
  'HC_Inc_Sml_Bal_All', 'HC_Inc_Med_Bal_All', 'HC_Inc_Lge_Bal_All',
  'RC_Inc_Lge_Bal_SM_6m', 'RC_Inc_Lge_Bal_Lge_6m',
  'Inc_Sml_Bal_All', 'Inc_Med_Bal_All', 'Inc_Lge_Bal_All',
  // Over credit limit
  'LP_OverLim20_Sml', 'LP_OverLim20_Med', 'LP_OverLim20_Lge',
  // County Court Judgment
  'NewJdgmnt_Sml', 'NewJdgmnt_Med', 'NewJdgmnt_Lge',
  // Bankruptcy
  'NewBAI',
  // Gone away flag
  'ToGA',
]);

const IMPROVING_ALERT_TYPES = new Set<AlertType>([
  // Account status getting better
  'HC_To0_All',
  'LP_DecTo3_All', 'LP_DecTo2_All', 'LP_DecTo1_All',
  'MG_DecTo3_All', 'MG_DecTo2_All', 'MG_DecTo1_All',
  'NL_DecTo3_All', 'NL_DecTo2_All', 'NL_DecTo1_All',
]);

export function getAlertImage(alertType: AlertType): AlertImage {
  if (IMPROVING_ALERT_TYPES.has(alertType)) return 'image_good';
  if (DECLINING_ALERT_TYPES.has(alertType)) return 'image_bad';
  return 'document';
}
